import { compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import reducers from "../reducers/reducers";
import sagas from "../saga/sagas";
import { persistStore, persistReducer } from "redux-persist";
import logger from "redux-logger";
import localforage from "localforage";
import { jwtDecode } from "jwt-decode";

const persistConfig = {
  key: "root",
  storage: localforage,
  timeout: null,
  setTimeout: null,
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistReducers = persistReducer(persistConfig, reducers);

const checkTokenExpirationMiddleware = () => (next) => (action) => {
  const token = localStorage.getItem("token");

  if (token !== null) {
    const decodedJwt = jwtDecode(token);
    if (decodedJwt.exp < Math.floor(Date.now() / 1000)) {
      localStorage.clear();
      next(action);
      window.location.reload();
    }
  }

  next(action);
};
const sagaMiddleware = createSagaMiddleware();
export const store = createStore(
  persistReducers,
  composeEnhancers(
    process.env.NODE_ENV === "development"
      ? applyMiddleware(checkTokenExpirationMiddleware, sagaMiddleware, logger)
      : applyMiddleware(checkTokenExpirationMiddleware, sagaMiddleware)
  )
);

export const persistedStore = persistStore(store);

sagaMiddleware.run(sagas);
